/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class t extends r{constructor(r,t,o){super(r,"mat4",1,(s,e,m)=>s.setUniformMatrix4fv(r,t(e,m),o))}}export{t as Matrix4PassUniform};
